module.exports = __webpack_public_path__ + "img/4.11dbc2de.jpg";